<template>
    <a-layout id="components-layout-demo-side" style="min-height: 100vh">
        <a-layout>
            <a-layout-content style="margin: 10%">
                <div :style="{ background: '#fff', padding: '26px'}">
                    <a-row>
                        <a-col style="text-align: center">
                            <img src="static/logoRH2.png" width="300px" alt="">
                        </a-col>
                    </a-row>
                    <a-row style="margin-top: 30px;">
                        <a-col>
                            <a-steps :current="current">
                                <a-step v-for="item in steps" :key="item.title" :title="item.title"/>
                            </a-steps>
                        </a-col>
                    </a-row>
                    <a-spin :spinning="loading">
                        <a-row style="margin-top: 30px;" v-show="current == 0">
                            <a-col>
                                <a-card>
                                    <p>Bievenido.</p>
                                    <p>
                                        Este es el primer paso en la creación/restauración de su contraseña para el ingreso al portal de autogestión de la herramienta HRO Cloud.</p>
                                    <p>
                                        Para una mejor experiencia y mayor rapidez durante el proceso, por favor tenga a la mano su documento de identidad y la información de su seguridad social.
                                    </p>
                                </a-card>
                            </a-col>
                        </a-row>
                        <a-row style="margin-top: 30px;" v-show="current == 1">
                            <a-col>
                                <a-card>
                                    <a-form :form="frmIdentificacion" @submit="validarIdentificacion">
                                        <a-form-item label="Identificación" v-bind="identificacionFiOptions">
                                            <a-input
                                                    placeholder="Identificación"
                                                    v-decorator="['identificacion', { rules: [{ required: true, message: 'Valor requerido' }] }]">
                                                <a-select slot="addonBefore" defaultValue="CC">
                                                    <a-select-option value="CC">CC</a-select-option>
                                                    <a-select-option value="CE">CE</a-select-option>
                                                    <a-select-option value="TI">TI</a-select-option>
                                                    <a-select-option value="PEP">PEP</a-select-option>
                                                </a-select>
                                            </a-input>
                                        </a-form-item>
                                    </a-form>
                                </a-card>
                            </a-col>
                        </a-row>
                        <a-row style="margin-top: 30px;" v-show="current == 2">
                            <a-col>
                                <a-card>
                                    <a-form :form="frmCuestionario" @submit="validarCuestionario">
                                        <a-form-item label="Correo Electrónico" v-bind="identificacionFiOptions">
                                            <a-input
                                                    placeholder="Correo electrónico"
                                                    v-decorator="['correo_electronico', { rules: [{ required: true, message: 'Valor requerido' },
                                                                                                   { pattern: modalPattern, message: 'Debe ser un correo válido.' }
                                                                                                  ]}]">
                                            </a-input>
                                        </a-form-item>
                                        <a-form-item label="Fecha de Nacimiento" v-bind="identificacionFiOptions">
                                            <a-date-picker
                                                    placeholder="Fecha de Nacimiento"
                                                    valueFormat="Y-MM-DD 00:00:00"
                                                    v-decorator="['fecha_de_nacimiento', { rules: [{ required: true, message: 'Valor requerido' }]}]"
                                                    style="width: 100%">
                                            </a-date-picker>
                                        </a-form-item>

                                        <a-form-item label="Grupo Sanguíneo" v-bind="identificacionFiOptions">
                                            <a-select style="width: 100%"
                                                      v-decorator="['grupo_sanguineo', {initialValue: 'A', rules: [{ required: true, message: 'Valor requerido' }]}]">
                                                <a-select-option value="A">A</a-select-option>
                                                <a-select-option value="AB">AB</a-select-option>
                                                <a-select-option value="B">B</a-select-option>
                                                <a-select-option value="O">O</a-select-option>
                                            </a-select>
                                        </a-form-item>

                                        <a-form-item label="Factor RH" v-bind="identificacionFiOptions">
                                            <a-select style="width: 100%"
                                                      v-decorator="['factor_rh', {initialValue: '+', rules: [{ required: true, message: 'Valor requerido' }]}]">
                                                <a-select-option value="+">+</a-select-option>
                                                <a-select-option value="-">-</a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </a-form>
                                </a-card>
                            </a-col>
                        </a-row>
                        <a-row style="margin-top: 30px;" v-show="current == 3">
                            <a-col>
                                <a-card>
                                    <a-form :form="frmNuevaClave" @submit="cambiarPassword">
                                        <a-form-item label="Nueva Clave" v-bind="identificacionFiOptions">
                                            <a-input type="password"
                                                     placeholder="Nueva Clave"
                                                     v-decorator="['nueva_clave', { rules: [
                                                       { required: true, message: 'Valor requerido' },
                                                       { type: 'string', validator: validatePasswordStatus }
                                                       ] }]">
                                            </a-input>
                                        </a-form-item>
                                        <a-form-item label="Repita la Contraseña" v-bind="identificacionFiOptions">
                                            <a-input type="password"
                                                     placeholder="Repita la Contraseña"
                                                     v-decorator="['repita_password', { rules: [
                                                      { required: true, message: 'Valor requerido'},
                                                      { required: true, validator: validatePassword, message: 'Las contraseñas no coinciden' }
                                                      ] }]">
                                            </a-input>
                                        </a-form-item>
                                    </a-form>
                                </a-card>
                            </a-col>
                        </a-row>
                        <a-row style="margin-top: 30px;" v-show="current == 4">
                            <a-col>
                                <a-card>
                                    <p>Felicitaciones!</p>
                                    <p>El proceso de creación/restauración de contraseñas ha concluído exitosamente.</p>
                                    <p>En estos momentos, puede cerrar esta ventana.</p>
                                </a-card>
                            </a-col>
                        </a-row>
                        <a-row style="margin-top: 30px;">
                            <a-col style="text-align: right">
                                <a-button type="danger" ghost v-if="current == 0"
                                          @click="finalizar">
                                    <a-icon type="left"/>
                                    Regresar al login
                                </a-button>
                                <a-button type="danger" ghost v-if="current > 0 && current < steps.length - 1"
                                          @click="prev">
                                    <a-icon type="left"/>
                                    Regresar
                                </a-button>
                                <a-button type="primary" ghost v-if="current < steps.length - 1" @click="next">
                                    Continuar
                                    <a-icon type="right"/>
                                </a-button>
                                <a-button type="primary" ghost v-if="current == steps.length - 1" @click="finalizar">
                                    Finalizar
                                </a-button>
                            </a-col>
                        </a-row>
                    </a-spin>
                </div>
            </a-layout-content>
            <a-layout-footer style="text-align: center">

            </a-layout-footer>
        </a-layout>
    </a-layout>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import DateUtils from '@/util/DateUtils'

  export default {
    data () {
      return {
        identificacionFiOptions: {
          'label-col': {span: 6},
          'wrapper-col': {span: 18},
          'has-feedback': true
        },
        current: 0,
        loading: false,
        frmIdentificacion: this.$form.createForm(this, {
          name: 'frmIdentificacion'
        }),
        frmCuestionario: this.$form.createForm(this, {
          name: 'frmCuestionario'
        }),
        frmNuevaClave: this.$form.createForm(this, {
          name: 'frmNuevaClave',
          onFieldsChange: (_, changedFields) => {
            this.formularioActualizado(changedFields)
          }
        }),
        password: '',
        passwordToken: '',
        steps: [
          {
            title: 'Bienvenida'
          },
          {
            title: 'Identificación'
          },
          {
            title: 'Cuestionario'
          },
          {
            title: 'Contraseña'
          },
          {
            title: 'Finalizar'
          }
        ],
        modalPattern: '(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])'
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      realizarPeticion (endPoint, values, okCallback) {
        this.loading = true
        this.httpClient.getInstance()
          .post('password_recovery/' + endPoint, values)
          .then(okCallback)
          .catch(this.manejaError)
      },
      validarIdentificacion (e) {
        e && e.preventDefault()
        this.frmIdentificacion.validateFields((err, values) => {
          if (!err) {
            this.realizarPeticion('validar_cedula', values, this.validaRespuesta)
          }
        })
      },
      validarCuestionario (e) {
        e && e.preventDefault()
        this.frmCuestionario.validateFields((err, values) => {
          if (!err) {
            this.realizarPeticion('validar_cuestionario', {
              ...values,
              fecha_de_nacimiento: DateUtils.forBackEnd(values.fecha_de_nacimiento),
              identificacion: this.frmIdentificacion.getFieldValue('identificacion')
            }, (response) => {
              if (parseInt(response.data.resultado) === 2) {
                this.passwordToken = response.data.token
              }
              this.validaRespuesta(response)
            })
          }
        })
      },
      cambiarPassword (e) {
        e && e.preventDefault()
        this.frmNuevaClave.validateFields(async (err, values) => {
          if (!err) {
            this.loading = true
            let gtoken = ''
            if (this.$store.state.appSettings.recaptcha.enabled) {
              await this.$recaptchaLoaded()
              // Execute reCAPTCHA with action "login".
              gtoken = await this.$recaptcha('reset_password')
            }

            this.realizarPeticion('update_password', {
              ...values,
              gtoken,
              'password_token': this.passwordToken
            }, this.validaRespuesta)
          }
        })
      },
      finalizar () {
        this.$router.push({
          name: 'Login'
        })
      },
      validaRespuesta (response) {
        if (parseInt(response.data.resultado) === 2) {
          this.current++
        } else {
          Mensajes.error('Error', response.data.mensaje)
        }
        this.loading = false
      },
      manejaError () {
        Mensajes.error('Error', 'No fue posible realizar la solicitud.')
        this.loading = false
      },
      next () {
        switch (this.current) {
          case 0:
            this.current++
            break
          case 1:
            this.validarIdentificacion()
            break
          case 2:
            this.validarCuestionario()
            break
          case 3:
            this.cambiarPassword()
            break
        }
      },
      prev () {
        this.current--
      },
      validatePasswordStatus (rule, value, callbackFn) {
        if (value.length < 8 || value.length > 12) {
          callbackFn('Debe tener entre 8 y 12 carácteres.')
          return false
        }

        /* debe tener una mayus */
        let contieneMayus = (/[A-Z]/.test(value))
        /* deebe terer una minus */
        let contieneMinus = (/[a-z]/.test(value))
        /* debe tener por lo menos un numero */
        let contieneNum = (/[0-9]/.test(value))

        if (!contieneMayus || !contieneMinus || !contieneNum) {
          callbackFn('Debe tener por lo menos una minuscula, una mayuscula y un número.')
        }
        callbackFn()
      },
      validatePassword (rule, value, callbackFn) {
        if (value === this.password) {
          callbackFn()
        }
        callbackFn('Error')
      },
      formularioActualizado (values) {
        this.password = this.frmNuevaClave.getFieldValue('nueva_clave')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/PasswordRecovery/PasswordRecovery.vue